import { render, staticRenderFns } from "./AdminUserFields.vue?vue&type=template&id=4c4d1d3b&scoped=true&"
import script from "./AdminUserFields.vue?vue&type=script&lang=js&"
export * from "./AdminUserFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4d1d3b",
  null
  
)

export default component.exports